var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrooveLogoinline = function SvgGrooveLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0076DB",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.476 0C4.7 0 0 4.7 0 10.477c0 5.776 4.7 10.476 10.476 10.476 5.777 0 10.477-4.7 10.477-10.476 0-2.45-.858-4.82-2.42-6.698l-3.399 2.455.885 1.25 2.158-1.559a8.949 8.949 0 0 1 1.244 4.552c0 4.932-4.012 8.945-8.945 8.945-4.932 0-8.945-4.013-8.945-8.945 0-4.933 4.013-8.945 8.945-8.945 1.745 0 3.455.513 4.681 1.38l1.384-.98C14.714.61 12.519 0 10.476 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.476 6.626a3.855 3.855 0 0 1 3.85 3.85 3.854 3.854 0 0 1-3.85 3.85 3.854 3.854 0 0 1-3.85-3.85 3.855 3.855 0 0 1 3.85-3.85zm0 2.521c-.733 0-1.33.596-1.33 1.33 0 .733.597 1.33 1.33 1.33a1.33 1.33 0 0 0 0-2.66z"
  }))));
};
export default SvgGrooveLogoinline;